import { React, useEffect, useState } from 'react';
import { motion } from "framer-motion";
import GoToSimulation from '../../common/GoToSimulation';
import { rootRoute } from '../../../config';
import animation_1 from '../assets/animation_1.png';
import step1 from '../assets/step1.png';
import step2 from '../assets/step2.png';
import step3 from '../assets/step3.png';
import step4 from '../assets/step4.png';
import { useOutletContext, useNavigate, useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';
import QmModuleStyle from '../styles/qm.module.css';
import review_doc_qm from '../assets/review_doc_qm.png';
import make_investment_qm from '../assets/make_investment_qm.png';
import watch_your_status_qm from '../assets/watch_your_status_qm.png';
import track_cost_revenue_qm from '../assets/track_cost_revenue_qm.png';
import restaurant_img from '../assets/restaurant_img.jpg';
import step3qm_medium from '../assets/step3qm_medium.png';
import step3qm_hard from '../assets/step3qm_hard.png';

const Introduction = () => {
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location] = useOutletContext();
  const navigate = useNavigate();
  const initIntro = () => {
    setSimPopup(false);
    setIsOverlay(false);
    setHeaderPopup(false);
    setIsArtifacts(false);
  }
  const [currentSection, setCurrentSection] = useState(1);
  const handleContinueBtn = () => {
    if (currentSection <= 5) {
      setCurrentSection(currentSection + 1);
    }
  };
  const location = useLocation();
  const fuSkipWalkThruPopups = () => {
    let readStatusLength = simObj?.artifacts?.filter((artifact) => artifact.readstatus == 1).length;
    return (simObj?.currentstep > 0 || simObj?.attemptno > 1 || readStatusLength > 0 || simObj?.decisionHistory != null || simObj?.decisionHistory?.length != 0)
  }
  // const check_Location = () => { 
  //   const queryParams = new URLSearchParams(location.search);
  //   if (queryParams.has('from') && queryParams.get('from') == "footer") {
  //     navigate(`${rootRoute}/im`);
  //   } else {
  //     fuSkipWalkThruPopups() && navigate(`${rootRoute}/qm/simulation`);
  //   }
  // }
  const checkNum = (num) => {
    return num < 0
      ? `-$${Math?.abs(num)?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`
      : `$${num?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`;
  };
  useEffect(() => {
    initIntro();
    if (document.querySelector("footer.footer .container") != null) {
      if (fuSkipWalkThruPopups()) {
        document.querySelector("footer.footer .container").style.justifyContent = "center";
      }
    }
    if (document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro") != null) {
      if (fuSkipWalkThruPopups()) {
        document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro").style.display = "block";
      }
    }
    // if(document.querySelector(".continue-link") != null){
    //   if(fuSkipWalkThruPopups()){
    //     document.querySelector(".continue-link").style.justifyContent = "space-between";
    //   }
    // }
    if (document.querySelectorAll("footer.footer .footer-nav .footer-links li:not(.skip-intro)").length > 0) {
      document.querySelectorAll("footer.footer .footer-nav .footer-links li:not(.skip-intro)").forEach((item) => {
        item.style.display = "none"
      });
    }
    document.title = "Quality Management | Introduction";
    return () => {
      if (document.querySelector("footer.footer .container") != null) {
        document.querySelector("footer.footer .container").style.justifyContent = "space-between";
      }
      if (document.querySelector("footer.footer .footer-nav .footer-links li:not(.skip-intro)") != null) {
        document.querySelectorAll("footer.footer .footer-nav .footer-links li:not(.skip-intro)").forEach((item) => {
          item.style.display = "block"
        });
      }
      if (document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro") != null) {
        document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro").style.display = "none";
      }
    }
  }, []);

  useEffect(() => {
    check_Location();
  }, [simObj]);
  return (
    <motion.div className={`${QmModuleStyle.intro} ${QmModuleStyle.sections}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
      <div className={`${QmModuleStyle.section}`} style={{ display: currentSection >= 1 ? "block" : "none" }}>
        <div className={`ui stackable two column grid ${QmModuleStyle.ui} ${QmModuleStyle.stackable} ${QmModuleStyle.column} ${QmModuleStyle.grid}`}>
          <div className={`column ${QmModuleStyle.column}`}>
            <div className={`${QmModuleStyle.content}`}> 
              <h2 className={`${QmModuleStyle['intro-heading']}`}>Introduction</h2>
              <h3 className={`${QmModuleStyle.situation}`}><strong>The Mission: </strong></h3>
              <p>You are the manager of one of the hottest Italian restaurants in town. You manage a full service staff and work closely with the chef and the owner to ensure the restaurant is providing a high-quality experience for customers. It is your job to make sure daily operations are running smoothly and that the investments you make to improve or maintain quality provides a return that exceeds the cost.</p>
              <h3 className={`${QmModuleStyle.goal}`}><strong>Your Goal: </strong></h3>
              <p>Earn {checkNum(simObj?.laststate?.yearlyProfitTarget)} in net profits from food and beverage sales. Timeline 1 year!</p>
            </div>
          </div>
          <div className={`column ${QmModuleStyle.column}`}>
            <div className={`${QmModuleStyle.image}`}>
              {/* <img src={animation_1} alt="introduction" /> */}
              <img src ={restaurant_img} alt="" />
            </div>
            <div className={`${QmModuleStyle.instr} ${QmModuleStyle.box}`}>
              <p className={`${QmModuleStyle.bgblue}`}>The simulation will take approximately <strong>20 minutes</strong> to complete and can be paused at any time.
              </p>
            </div>
          </div>
        </div>
        <hr aria-hidden="true" />
        <div
          className={`${QmModuleStyle['continue-link']}`}
          style={{ display: currentSection > 1 ? "none" : "flex" }}
        >
          {
            fuSkipWalkThruPopups() && <Link to={`${rootRoute}/qm/simulation`} className={`${QmModuleStyle['skip-intro']}`} role="button">
              <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
            </Link>
          }
          <a href="#step1" onClick={handleContinueBtn} role="button">
            {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
          </a>
        </div>
      </div>
      <div className={`${QmModuleStyle.section}`} style={{ display: currentSection >= 2 ? "block" : "none" }}>
        <div className={`${QmModuleStyle.step}`} id="step1">
          <div className={`ui stackable two column grid ${QmModuleStyle.ui} ${QmModuleStyle.stackable} ${QmModuleStyle.column} ${QmModuleStyle.grid}`}>
            <div className={`column ${QmModuleStyle.column}`}>
            <h2>Step 1: Review Documents</h2>
              <div className={`${QmModuleStyle.content}`}>
                <p>First, you will need to go through your incoming documents like reviews, emails, and chats in order to familiarize yourself with the scenario specifics. Read these items carefully since they contain clues on how to best understand and solve problems. Be sure to check new information, which is indicated with an alert <span className={`${QmModuleStyle['red-circle']}`} aria-hidden="true" role='presentation'>2</span> <span className="sr-only">icon indicating 2 new items</span>.</p>
              </div>
            </div>
            <div className={`column ${QmModuleStyle.column}`}>
              <div className={`${QmModuleStyle.image}`}>
                <img src={review_doc_qm} alt="An image displays a webpage with an open email dialog box, along with a reviews and messages icon and a list of multiple emails visible on the page." />
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${QmModuleStyle['continue-link']}`}
            style={{ display: currentSection > 2 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/qm/simulation`} className={`${QmModuleStyle['skip-intro']}`} role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#step2" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${QmModuleStyle.section}`} style={{ display: currentSection >= 3 ? "block" : "none" }}>
        <div className={`${QmModuleStyle.step}`} id="step2">
          <h2>Step 2: Make Investment</h2>
          <div className={`ui stackable two column grid ${QmModuleStyle.ui} ${QmModuleStyle.stackable} ${QmModuleStyle.column} ${QmModuleStyle.grid}`}>
            <div className={`column ${QmModuleStyle.column}`}>
              <div className={`${QmModuleStyle.image}`}>
                <img src={make_investment_qm} alt="An image displays a section of a webpage with Available Investments tab selected under make investment section, along with Utilized Investments tab not seletcted." />
              </div>
            </div>
            <div className={`column ${QmModuleStyle.column}`}>
              <div className={`${QmModuleStyle.content}`}>
                <p>Next you will need to make an investment to improve quality within the restaurant.  Make sure to review all your materials and all the options to best address any current problems.</p>  
                <br/>
                <p> You can make any investments you feel necessary throughout the simulation as long as you have the available cash.  Your reviews and incoming communications will guide you on where you may want to make your investments.  Your choices of investments will impact your revenue,  costs, and quality over the course of the simulation.</p>
              </div>
            </div>

          </div>
          <hr aria-hidden="true" />
          <div
            className={`${QmModuleStyle['continue-link']}`}
            style={{ display: currentSection > 3 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/qm/simulation`} className={`${QmModuleStyle['skip-intro']}`} role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#step3" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${QmModuleStyle.section}`} style={{ display: currentSection >= 4 ? "block" : "none" }}>
      <div id="step3" className={`${QmModuleStyle.step}`}>
          <div className={`ui stackable two column grid ${QmModuleStyle.ui} ${QmModuleStyle.stackable} ${QmModuleStyle.column} ${QmModuleStyle.grid}`}>
            <div className={`column ${QmModuleStyle.column}`}>
              <h2>Step 3: Watch Your Status</h2>
              <div className={`${QmModuleStyle.content}`}>
                <p>
                There are several different meters to judge how well you are doing overall.  They are located at the top of the simulation screen.  They are the Total Cost of Quality, Available Cash, Average Failure Rate, Profit & Loss against your goal, and the Review Rating.  Check your Profit & Loss and Review Rating often to make sure you're on track for success.</p>
              </div>
            </div>
            <div className={`column ${QmModuleStyle.column}`}>
              <div className={`${QmModuleStyle.image}`}>
                <img src={((simObj?.laststate?.level == "MEDIUM") && (simObj?.hasOwnProperty("version") && simObj?.version > 1)) ? step3qm_medium : ((simObj?.laststate?.level == "HARD") && (simObj?.hasOwnProperty("version") && simObj?.version > 1)) ? step3qm_hard : watch_your_status_qm} alt="Total Profits for the Year meter and Star Rating meter" />
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${QmModuleStyle['continue-link']}`}
            style={{ display: currentSection > 4 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/qm/simulation`} className={`${QmModuleStyle['skip-intro']}`}  role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#step4" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>


       
      </div>
      <div className={`${QmModuleStyle.section}`} style={{ display: currentSection >= 5 ? "block" : "none" }}>
      <div id="step4" className={`${QmModuleStyle.step} ${QmModuleStyle['track-cost-step']}`}>
        <div className={`ui stackable two column grid ${QmModuleStyle.ui} ${QmModuleStyle.stackable} ${QmModuleStyle.column} ${QmModuleStyle.grid}`}>
            <div className={`column ${QmModuleStyle.column}`}>
              <h2>Step 4: Track Costs & Revenues</h2>
              {/* <div className={`${QmModuleStyle.step3main}`}> */}
              <div className={`${QmModuleStyle.content}`}>
                <p>As the simulation begins running, each "day" takes approximately 1 second.  Your Revenue/Costs of Quality will be displayed on the left and your failure rate will be charted on the right.  Both charts are updated daily.  You will want to monitor these to make informed quality investment decisions.</p>
              </div>
            </div>
            <div className={`column ${QmModuleStyle.column}`}>
              <div className={`${QmModuleStyle.image}`}>
                <img src={track_cost_revenue_qm} alt="Revenue/Costs of quality graph and Failure Rate graph" />
              </div>
            </div>
        </div>
          {/* </div> */}
          <hr aria-hidden="true" />
          <div
            className={`${QmModuleStyle['continue-link']}`}
            style={{ display: currentSection > 5 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/qm/simulation`} className={`${QmModuleStyle['skip-intro']}`} role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#cardSec" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div style={{ display: currentSection >= 6 ? "block" : "none" }}>
        <div className="key-to-succ-sec">
          <div className={`${QmModuleStyle.bggray}`} id="cardSec">
            <div className={`${QmModuleStyle['keys-to-succ']}`}>
              <div style={{ "paddingTop": "20px" }}>
                <h2 className={`${QmModuleStyle['card-heading']}`}>Keys to Success</h2>
              </div>
              <div className={`${QmModuleStyle['card-wrapper']}`}>
                <div className={`ui card ${QmModuleStyle.ui} ${QmModuleStyle.card}`}>
                  <div>
                    <div className={`header center aligned ${QmModuleStyle.header} ${QmModuleStyle.aligned}`}>
                      <h3>Stay Informed</h3>
                    </div>
                  </div>
                  <p className={`content center aligned ${QmModuleStyle.content} ${QmModuleStyle.aligned}`}>
                    Your decisions are only as good as the information they are based on. Pay attention to indicators and read new messages as they come in.
                  </p>
                </div>

                <div className={`ui card ${QmModuleStyle.ui} ${QmModuleStyle.card}`}>
                  <div>
                    <div className={`header center aligned ${QmModuleStyle.header} ${QmModuleStyle.aligned}`}>
                      <h3>Be Adaptable</h3>
                    </div>
                  </div>
                  <p className={`content center aligned ${QmModuleStyle.content} ${QmModuleStyle.aligned}`}>
                    This simulation puts the course concepts into a real-world context where circumstances are changing. Don’t be afraid to make decisions when necessary.
                  </p>
                </div>

                <div className={`ui card ${QmModuleStyle.ui} ${QmModuleStyle.card}`}>
                  <div>
                    <div className={`header center aligned ${QmModuleStyle.header} ${QmModuleStyle.aligned}`}>
                      <h3>Be Patient</h3>
                    </div>
                  </div>
                  <p className={`content center aligned ${QmModuleStyle.content} ${QmModuleStyle.aligned}`}>
                    Sometimes the best course of action is to see how your decisions play out over longer time periods.
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="section">
          <GoToSimulation />
        </div>
      </div>
    </motion.div>
  )
}

export default Introduction